import { IconAttention, Space, SubText } from '@procurify/ui'

import { FormattedShortDate } from '@webapp/core/components/FormattedDate/FormattedShortDate'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

export const DateCell = ({ date, isOverdue }: ColumnTypeData['DATE']) => {
  const intl = useProcurifyIntl()

  return (
    <Space size='xsmall'>
      <FormattedShortDate date={date} />
      {isOverdue ? (
        <Space direction='horizontal' size='xsmall' align='center'>
          <IconAttention color='danger' />
          <SubText color='danger' bold>
            {intl.formatMessage(messages.overdueLabel)}
          </SubText>
        </Space>
      ) : null}
    </Space>
  )
}
